<template lang="html">

  <article class="noticia-el row-center ais" :destacada="destacada">


    <div class="contenedor-imagen">

      <img src="/static/img/imagen-home-togo.jpg" alt="imagen-home">
      
    </div>

    <div class="contenedor-texto">
      <h3 class="fecha">{{data.fecha.day}} {{$t(`formulario.meses[${data.fecha.month-1}]`)}} {{data.fecha.year}}</h3>
      <h2>{{data.titulo}}</h2>
      <p>{{data.entradilla}}</p>
      <router-link :to="$t('enlaces.noticia')+'/'+data.slug" class="btn with-border">Leer noticia</router-link>
    </div>
      
    <router-link :to="$t('enlaces.noticia')+'/'+data.slug" class="enlace-cover"></router-link>

  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'noticia',
    props: ['data','destacada'],
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
}
</script>

<style scoped lang="scss">
  .noticia-el {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue